import React from 'react';
import TeacherPremium from '../containers/TeacherPremium';

export default (props) => (
  <TeacherPremium {...props} />
);
